import axios from "axios";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import {
  HardSkillsFilter,
  LocationFilter,
  SoftSkillsFilter,
  UsedLanguagesFilter,
} from "../../../components/common";
import RequiredFieldIcon from "../../../components/common/RequiredFieldIcon";
import AreaOfExperties from "../../../components/Filters_Projects/AreaOfExpertiesFilter";
import DescriptionFilter from "../../../components/Filters_Projects/DescriptionFilter";
import ForGratification from "../../../components/Filters_Projects/ForGratificationFilter";
import OfferedGratification from "../../../components/Filters_Projects/OfferedGratificationFilter";
import OfferedWorkingType from "../../../components/Filters_Projects/OfferedWorkingTypeFilter";
import ProductType from "../../../components/Filters_Projects/ProductTypeFilter";
import ProjectDeadline from "../../../components/Filters_Projects/ProjectDeadlineFilter";
import ProjectName from "../../../components/Filters_Projects/ProjectNameFilter";
import ProjectType from "../../../components/Filters_Projects/ProjectTypeFilter";
import Availability from "../../../components/Filters_Projects/RequiredAvailabilityFilter";
import ToolsExperienceFilter from "../../../components/Filters_Projects/ToolsExperienceFilter";
import { FILTERS } from "../../../filters/filtersConfig";
import { url } from "../../../url";
import { useDataFromAddProjects } from "../../../utils/useDataFromAddProject";
import { useOpenCloseFiltersAddProject } from "../../../utils/useOpenCloseFiltersAddProject";
import { openAtom, pageAtom } from "../atoms/AddProjectAtomGlobal";
import {
  forGratificationAtom,
  offeredGratificationAtom,
  productTypeAtom,
  projectNameAtom,
  projectTypeAtom,
  requiredAreaOfExpertiseAtom,
  softSkillsAtom,
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
} from "../atoms/AddProjectAtomPage1";
import {
  descriptionAtom,
  hardSkillsAtom,
  offeredWorkingTypeActiveOptionsAtom,
  offeredWorkingTypeAtomNewArray,
  projectDeadlineAtom,
} from "../atoms/AddProjectAtomPage2";
import {
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  locationsAtom,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  requiredAvailabilityAtomStartValue,
  usedLanguagesAtom,
} from "../atoms/AddProjectAtomPage3";

import "./NewAddProject.scss";

const Page1 = () => {
  const setPage = useSetAtom(pageAtom);
  const [projectName, setProjectName] = useAtom(projectNameAtom);
  const [toolsExperience, setToolsExperience] =
    useAtom<string[]>(toolsExperienceAtom);
  const [toolsExperienceOptionViews, setToolsExperienceOptionViews] = useAtom(
    toolsExperienceOptionViewsAtom
  );
  const [productType, setProductType] = useAtom<string[]>(productTypeAtom);
  const [projectType, setProjectType] = useAtom<string[]>(projectTypeAtom);
  const [offeredGratification, setOfferedGratification] = useAtom<string[]>(
    offeredGratificationAtom
  );
  const [softSkills, setSoftSkills] = useAtom<string[]>(softSkillsAtom);
  const [requiredAreaOfExpertise, setRequiredAreaOfExpertise] = useAtom<
    string[]
  >(requiredAreaOfExpertiseAtom);
  const [forGratification, setForGratification] =
    useAtom<string[]>(forGratificationAtom);
  const openFilters = useAtomValue(openAtom);
  const enableAndResetFilters = useOpenCloseFiltersAddProject();
  const data = useDataFromAddProjects();
  const navigate = useNavigate();
  const [projectDeadline, setProjectDeadline] = useAtom(projectDeadlineAtom);
  const [hardSkills, sethardSkills] = useAtom<string[]>(hardSkillsAtom);
  const [offeredWorkingTypeNewArray, setOfferedWorkingTypeNewArray] = useAtom<
    string[]
  >(offeredWorkingTypeAtomNewArray);
  const [offeredWorkingTypeActiveOptions, setOfferedWorkingTypeActiveOptions] =
    useAtom<boolean[]>(offeredWorkingTypeActiveOptionsAtom);
  const [description, setDescription] = useAtom(descriptionAtom);
  const [usedLanguages, setUsedLanguages] =
    useAtom<string[]>(usedLanguagesAtom);
  const [bizOrTechRoleLeftValue, setBizOrTechRoleLeftValue] = useAtom(
    bizOrTechRoleAtomLeftValue
  );
  const [bizOrTechRoleRightValue, setBizOrTechRoleRightValue] = useAtom(
    bizOrTechRoleAtomRightValue
  );
  const [requiredAvailabilityStartValue, setRequiredAvailabilityStartValue] =
    useAtom(requiredAvailabilityAtomStartValue);
  const [requiredAvailabilityEndValue, setRequiredAvailabilityEndValue] =
    useAtom(requiredAvailabilityAtomEndValue);
  const [requiredAvailabilityOption, setRequiredAvailabilityOption] = useAtom(
    requiredAvailabilityAtomOption
  );
  const [locations, setLocations] = useAtom<string[]>(locationsAtom);

  const clearFilters = () => {
    setProjectName("");
    setDescription("");
    setProjectDeadline(0);
    setProjectType([]);
    setProductType([]);
    setRequiredAreaOfExpertise([]);
    sethardSkills([]);
    setSoftSkills([]);
    setToolsExperience([]);
    // setToolsExperienceOptionViews(
    //   toolsExperienceOptionViews.reduce((acc: any, option: string) => {
    //     acc[option] = 1;
    //     return acc;
    //   }, {})
    // );
    setUsedLanguages([]);
    setOfferedGratification([]);
    setForGratification([]);
    setOfferedWorkingTypeNewArray([]);
    setOfferedWorkingTypeActiveOptions([]);
    setLocations([]);
    setRequiredAvailabilityStartValue(10);
    setRequiredAvailabilityEndValue(15);
    setRequiredAvailabilityOption("Monthly");
    setBizOrTechRoleLeftValue("");
    setBizOrTechRoleRightValue("");
  };
  const onClickSubmitButton = async () => {
    const token = localStorage.getItem("token");
    try {
      if (
        projectName.length &&
        toolsExperience.length &&
        projectType.length &&
        productType.length &&
        offeredGratification.length &&
        forGratification.length
      ) {
        const res = await axios.post(url + "/project", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(res.data);
        clearFilters();
        navigate(`/projects/my`);
      } else {
        alert("You need to fill required fields");
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div style={{ width: "100%", padding: "20px" }}>
      <div
        className="page1_component"
        style={{ maxWidth: "100%", paddingBottom: 88 }}
      >
        <div className="columns-container-project" style={{ gap: 24 }}>
          <div className="column-project" style={{ display: "flex", gap: 24 }}>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ProjectName
                projectName={projectName}
                setProjectName={setProjectName}
                show={openFilters.projectName}
                setShow={enableAndResetFilters}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ProductType
                pickedOptions={productType}
                setPickedOptions={setProductType}
                show={openFilters.productType}
                setShow={enableAndResetFilters}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ToolsExperienceFilter
                pickedOptions={toolsExperience}
                setPickedOptions={setToolsExperience}
                optionViews={toolsExperienceOptionViews}
                setOptionViews={setToolsExperienceOptionViews}
                show={openFilters.toolsExperience}
                setShow={enableAndResetFilters}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ProjectType
                pickedOptions={projectType}
                setPickedOptions={setProjectType}
                show={openFilters.projectType}
                setShow={enableAndResetFilters}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <OfferedGratification
                pickedOptions={offeredGratification}
                setPickedOptions={setOfferedGratification}
                show={openFilters.offeredGratification}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ForGratification
                pickedOptions={forGratification}
                setPickedOptions={setForGratification}
                show={openFilters.forGratification}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
            </div>
            <HardSkillsFilter
              pickedOptions={hardSkills}
              setPickedOptions={sethardSkills}
              show={openFilters.hardSkills}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />
            <AreaOfExperties
              pickedOptions={requiredAreaOfExpertise}
              setPickedOptions={setRequiredAreaOfExpertise}
              show={openFilters.requiredAreaOfExpertise}
              setShow={enableAndResetFilters}
              isAdd={true}
            />
            <ProjectDeadline
              value={projectDeadline}
              setValue={setProjectDeadline}
              open={openFilters.projectDeadline}
              setOpen={enableAndResetFilters}
              showFilterType={false}
              isAdd={true}
            />
          </div>

          <div className="column-project" style={{ display: "flex", gap: 24 }}>
            <SoftSkillsFilter
              pickedOptions={softSkills}
              setPickedOptions={setSoftSkills}
              show={openFilters.softSkills}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />

            <Availability
              startValue={requiredAvailabilityStartValue}
              setStartValue={setRequiredAvailabilityStartValue}
              endValue={requiredAvailabilityEndValue}
              setEndValue={setRequiredAvailabilityEndValue}
              selectedOption={requiredAvailabilityOption}
              setSelectedOption={setRequiredAvailabilityOption}
              open={openFilters.requiredAvailability}
              setOpen={enableAndResetFilters}
              title={FILTERS.requiredAvailability.label}
              showFilterType={false}
              isAdd={true}
            />
            <OfferedWorkingType
              newArray={offeredWorkingTypeNewArray}
              setNewArray={setOfferedWorkingTypeNewArray}
              activeOptions={offeredWorkingTypeActiveOptions}
              setActiveOptions={setOfferedWorkingTypeActiveOptions}
              show={openFilters.offeredWorkingType}
              setShow={enableAndResetFilters}
              isAdd={true}
            />
            <LocationFilter
              pickedOptions={locations}
              setPickedOptions={setLocations}
              show={openFilters.locations}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />
            <UsedLanguagesFilter
              pickedOptions={usedLanguages}
              setPickedOptions={setUsedLanguages}
              show={openFilters.usedLanguages}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />
            {/* <BizOrTechRole
              leftValue={bizOrTechRoleLeftValue}
              setLeftValue={setBizOrTechRoleLeftValue}
              rightValue={bizOrTechRoleRightValue}
              setRightValue={setBizOrTechRoleRightValue}
              open={openFilters.bizOrTech}
              setOpen={enableAndResetFilters}
            /> */}

            <DescriptionFilter
              description={description}
              setDescription={setDescription}
            />
          </div>
        </div>
      </div>
      <div className="buttons_container">
        <div>
          <button className="submit_btn" onClick={onClickSubmitButton}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};
export default Page1;
